<template>
  <div class="popup_wrap">
    <span class="ticket_btnbox">
      <span class="checkbox" @click="mustRead">
        <input type="checkbox" id="mkt-agree-checkbox" v-model="inputVal" />
        <label for="mkt-agree-checkbox">150분 할인권, 이용 시 필수 조건 확인</label>
      </span>
      <a class="openPopup" @click="openModal">전문보기</a>
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="150분 할인권, 이용 시 필수 조건 확인">
      <!-- default 슬롯 콘텐츠 -->
      <div>
        <p class="mb20">
          · 구매대상 : 단체이용객 (체험자 15명 이상)
          <br />
          <br />
          ※본 할인권은 단체고객 한정 판매상품입니다.
          <br />
          <br />
          ※15인 미만 이용 시, 이용불가 (일반권 구매)
          <br />
          <br />
          · 이용시간 : 14:30~17:00 (150분 이용)
          <br />
          <br />
          ※17:00 이후에는 어린이체험관에 체류할 수 없습니다.
          <br />
          <br />
          · 연속 이용할인 : 1회차 이용단체 50%할인
          <br />
          <br />
          ※당일 1회차 이용 단체 한정
        </p>
      </div>
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap tcen">
          <a class="wdhalf btn btn_bg gray" @click="() => onMoreClick(false)">돌아가기</a>
          <a class="wdhalf btn btn_bg color" @click="() => onButtonClick(true)">확인</a>
        </div>
        <!-- <button @click="selectPcnt">확인</button>
        <button @click="closeModal">취소</button> -->
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
export default {
  components: { Modal },
  props: ['value', 'id'],
  data() {
    return {
      modal: {
        open: false,
      },
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {},
  methods: {
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    mustRead(e) {
      if (!this.value) {
        e.stopPropagation();
        e.preventDefault();
        this.modal.open = true;
      }
    },
    onButtonClick(agree) {
      this.$emit('input', agree);
      this.closeModal();
    },
    onMoreClick(agree) {
      window.scrollTo(0, 0);
      this.$emit('input', agree);
      this.closeModal();
      this.$router.push('/grp');
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }
}
</style>
